import * as React from 'react';
import * as styles from './styles.css';
import { InlineText2 } from '@cian/ui-kit/typography';

export const Subtext: React.FC = props => {
  return (
    <div className={styles['sub']}>
      <InlineText2 color="black_60">{props.children}</InlineText2>
    </div>
  );
};

Subtext.displayName = 'Subtext';
